import React, { useEffect } from 'react'
import { Card } from 'react-bootstrap'
import { useState } from "react";
import { useNavigate } from 'react-router';
import axios from "axios";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import { useDispatch } from "react-redux";
import { setLoader } from '../Store/Reducers/UserReducer';
import moment from "moment";
import LoginFun from '../Layout Component/Loginfun';
import Swal from "sweetalert2";
import './ObservationResult.css';
import { toast } from 'react-toastify';
import ObservationOverview from './ObservationOverview';
import VitalsPanel from './VitalsPanel';
import VitalsGraphs, { isVitalLine } from './VitalsGraphs';
import { printResults } from './resultsPrint';
import { readEntries, entriesAsResults, readClinicBody } from './vitalsStore';
var UserData;

// Which tab was last open, so coming back from a full HL7 report lands where
// the reader left. Storage can be unavailable; the first tab is the fallback.
const TAB_KEY = "ObservationResultTab";
function readTab() {
  try {
    return sessionStorage.getItem(TAB_KEY) === "pivot" ? "pivot" : "overview";
  } catch {
    return "overview";
  }
}

export default function ObservationResult(props) {
  UserData = JSON.parse(localStorage.getItem("UData"));
  const { SetSendData } = props;
  const url = process.env.REACT_APP_OXAR_API_URL;
  const datalogin = LoginFun();
  const [observations, setobservations] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pivotarray, setpivotarray] = useState([]);
  const [settings, setSettings] = useState({});
  const [observationsContactdata, setobservationsContactdata] = useState();
  const [observationsError, setobservationsError] = useState(null);
  const [tab, setTab] = useState(readTab);
  const [vitals, setVitals] = useState(readEntries);
  const [clinicBody, setClinicBody] = useState({});

  const chooseTab = (next) => {
    setTab(next);
    try {
      sessionStorage.setItem(TAB_KEY, next);
    } catch {
      // Remembering the tab is a convenience only.
    }
  };

  useEffect(() => {
    dispatch(setLoader(true));
    var currentTime = '';
    var Expiretime = localStorage.getItem("ExpirretokenTime");
    currentTime = (Math.round(new Date().getTime() / 1000));
    if (Expiretime < currentTime) {
       dispatch(setLoader(false));
      sessionStorage.getItem('isLoggedIn', false)
      Swal.fire({
        title: 'Session Expired',
        text: "Your session has been expired! Please login again",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Okay',
      }).then(result => {
        datalogin.logout();
      })
    }
     setTimeout(() => {
      getObservations();
      getObservationsbycontactid();
      readClinicBody().then(setClinicBody).catch(() => {});
    }, 1000);
  }, []);

  // ONLY APPROVED RESULTS. The patient portal shows a result once the clinic
  // has approved it, and never the clinic's notes. The approval flag is on the
  // order (GetObservationByContactId), so the result lines are fetched per
  // approved order — the patient-wide result call would return unapproved
  // lines as well. (The API should enforce this too; this is the portal's
  // half of the rule.)
  const getObservations = async () => {
    try {
      dispatch(setLoader(true));
      let MainUserId = localStorage.getItem("UserID");
      const orders = await axios(`${url}api/TDLObservation/GetObservationByContactId?id=${MainUserId}`);
      const approved = (orders.data.content || []).filter((o) => o.approve === true);
      const lines = await Promise.all(
        approved.map((o) =>
          axios(`${url}api/TDLObservation/GetObservationResultByObservationIdH17?id=${o.id}`)
            .then((r) => (r.data.content || []).map((l) => ({
              ...l,
              // A line with no time of its own takes its order's.
              dateTimeofTransaction: l.dateTimeofTransaction || o.transactionDateTime,
              // Clinic notes are not for the patient.
              notes1: undefined, notes2: undefined, notes3: undefined, notes4: undefined,
            })))
            .catch(() => [])),
      );
      const all = lines.flat();
      setobservations(all);
      onload(all);
      dispatch(setLoader(false));
    }
    catch {
       setobservationsError("Your results could not be loaded. Please refresh the page to try again.");
       dispatch(setLoader(false));
    }
  };


  const getObservationsbycontactid = async () => {
    debugger
    try {
      dispatch(setLoader(true));
      let MainUserId = localStorage.getItem("UserID");
        await axios(`${url}api/TDLObservation/GetObservationByContactId?id=${MainUserId}`).then((res) => {
          
          // Approved results only; the clinic's comments are never sent on.
          setobservationsContactdata((res.data.content || []).filter((o) => o.approve === true).map((o) => ({ ...o, doctorsComment: undefined })));
          dispatch(setLoader(false));
        });
    }
    catch {
       dispatch(setLoader(false));
    }
  };


  const onload = async (results) => {
    debugger
    var pivotarray1 = [];
    var datearray = [];
    function formatDate(date) {
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      var time = date.toLocaleTimeString();

      return day + '-' + monthNames[monthIndex] + '-' + year + ' ' + time;
    }

    for (var i = 0; i < results.length; i++) {
      
      var pivottablem = {
        // Date_Of_Test: formatDate(new Date(results[i]["dateTimeofTransaction"])),
        Date_Of_Test: moment(results[i]["dateTimeofTransaction"]).format("DD-MMM-YYYY"),
        Value: results[i]["observationValue"],
        Test: results[i]["text"],
        Unit: results[i]["units"],
        Range: results[i]["referenceRange"],
        Code: results[i]["identifier"],
        Flag: results[i]["abnormalFlags"],
      }
      pivotarray1.push(pivottablem);
      // setpivotarray(pivotarray1);
      datearray.push(results[i]["dateTimeofTransaction"]);
    }
    setpivotarray(pivotarray1);
  };
  const Test = async (data) => {
    
    const sendata = data;
    var Observationid = data.id;
    localStorage.setItem("ObservationId", Observationid);
    SetSendData(sendata)
    navigate('/HL7ObservationDetail')
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>


        <Card className=' border-0 '>
          {/* <Card.Header className=' colorprofile  text-light'><h5>Observation Result</h5></Card.Header> */}
          <div className='card-header mb-2'>
            <div className="row">
              <div className="col">
                <h5>Observation Result </h5>
              </div>
              <div className="col text-right">
                <button type="button" className="ox-btn me-2" onClick={() => {
                  if (!printResults({ lines: observations || [], entries: vitals, clinic: clinicBody })) toast.warn("Your browser blocked the print window. Please allow pop-ups for this site.");
                }}>Print results</button>
                ( {UserData?.firstName} {UserData?.lastName} , {moment(UserData?.birthday).format("DD-MMM-YYYY")} ({UserData?.age}) ,{UserData?.gendercodeName} )
              </div>
            </div>
          </div>
          <Card.Body>
            {/* Two views of the same results. The overview is new; the pivot
                table and the list of result sets are the page as it was. */}
            <ul className="nav nav-tabs obv-tabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  type="button"
                  role="tab"
                  aria-selected={tab === "overview"}
                  className={`nav-link${tab === "overview" ? " active" : ""}`}
                  onClick={() => chooseTab("overview")}
                >
                  Results overview
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  type="button"
                  role="tab"
                  aria-selected={tab === "pivot"}
                  className={`nav-link${tab === "pivot" ? " active" : ""}`}
                  onClick={() => chooseTab("pivot")}
                >
                  Pivot table &amp; reports
                </button>
              </li>
            </ul>

            {tab === "overview" && (
              <>
              <VitalsPanel entries={vitals} onChange={setVitals} clinicWeight={clinicBody.weight} clinicHeight={clinicBody.height} />
              <VitalsGraphs lines={observations || []} entries={vitals} clinic={clinicBody} />
              <ObservationOverview
                results={observations === undefined ? undefined : observations.filter((l) => !isVitalLine(l))}
                sets={observationsContactdata}
                loading={observations === undefined && !observationsError}
                error={observationsError}
                onOpenReport={Test}
              />
              </>
            )}

            {tab === "pivot" && (
            <Card.Text as="div">
              {/* step wizard for Medical History */}
              <div className='col-md-12   mt-3'>
                <Card.Body>

                  <div className="">
                    <div className='container px-md-0 table-responsive '>
                      <PivotTableUI
                        data={pivotarray}
                        onChange={(s) => setSettings(s)}
                        rows={["Date_Of_Test"]}
                        cols={["Test", "Unit"]}
                        vals={["Value"]}
                        aggregatorName="Last"
                        rendererName="Table Col Heatmap"
                        showAggregationOnValueField="false"
                        {...settings}
                      />
                    </div>

                  </div>
                  <br></br>

                  <div className='table-responsive'>
                    {observations ?
                      <table className="table  table-hover" id="observationsContactdata">
                        <thead className="thead-light">
                          <tr>
                            <th>Name</th>
                            <th>Observation</th>
                            <th>Order Status</th>
                            <th>Status</th>
                            <th>Date/Time of Transaction</th>
                            <th>Consulting Doctor</th>
                            <th>Created on </th>
                          </tr>
                        </thead>
                        <tbody>
                          {observationsContactdata && observationsContactdata.map((listValue, index) => {
                            return (
                              <tr key={index} onClick={() => Test(listValue)}>
                                <td onClick={() => navigate('/HL7ObservationDetail')} id='seprateantortag' style={{ cursor: 'pointer' }} className='text-info'>{listValue.name}</td>
                                <td>{listValue.observationbundle}</td>
                                <td>
                                  {
                                    listValue.orderStatus === 271400002 ? "CM -Order is Completed" :
                                      listValue.orderStatus === 271400001 ? "CA -Order was canceled" :
                                        listValue.orderStatus === 271400000 ? "A -Some but not all results available" :
                                          listValue.orderStatus === 271400003 ? "CM -Order is DC -Order was discontinued" :
                                            listValue.orderStatus === 271400004 ? "ER -Error order not found" :
                                              listValue.orderStatus === 271400005 ? "HD -order is on hold" :
                                                listValue.orderStatus === 271400006 ? "IP -In process unspecified" :
                                                  listValue.orderStatus === 271400007 ? "RP -Order has been replaced" :
                                                    listValue.orderStatus === 271400008 ? "SC -In process scheduled" : null
                                  }
                                </td>
                                <td>
                                  {
                                    listValue.status === 271400000 ? "Final" :
                                      listValue.status === 271400001 ? "NA" : null
                                  }

                                </td>
                                <td>{moment(listValue.transactionDateTime).format('DD-MMM-YYYY')}</td>
                                <td>{listValue.consultingDoctor}</td>
                                <td>{moment(listValue.createdOn).format('DD-MMM-YYYY')}</td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      : null
                    }
                  </div>


                </Card.Body>
              </div>
            </Card.Text>
            )}
          </Card.Body>
        </Card>

      </div>
    </>
  )
}
